module.exports = __webpack_public_path__ + "static/media/Signature.9030526a.png";